import {useQuery, gql} from 'admin/lib/apollo'
import {NumberParam, StringParam, useQueryParams, withDefault} from 'use-query-params'

export const QUERY = gql`
  query GetInvoices(
    $fromDate: String
    $toDate: String
    $fromAmount: String
    $toAmount: String
    $q: String
    $page: Int
    $limit: Int
    $sortBy: String
    $sortDirection: String
  ) {
    invoices(
      fromDate: $fromDate
      toDate: $toDate
      fromAmount: $fromAmount
      toAmount: $toAmount
      q: $q
      page: $page
      limit: $limit
      sortBy: $sortBy
      sortDirection: $sortDirection
    ) {
      collection {
        id
        date
        dueDate
        invoiceNumber
        amount
        isSendable
        isSent
        xeroLink
        state
        account {
          id
          name
          displayName @client
          contactFullName @client
          contactFirstName
          contactLastName
        }
      }
      metadata {
        totalCount
      }
    }
  }
`

export default organisationId => {
  const [filters, setFilters] = useQueryParams({
    q: withDefault(StringParam, ''),
    fromDate: withDefault(StringParam, ''),
    toDate: withDefault(StringParam, ''),
    fromAmount: withDefault(StringParam, ''),
    toAmount: withDefault(StringParam, ''),
    sortBy: withDefault(StringParam, 'date'),
    sortDirection: withDefault(StringParam, 'desc'),
    page: withDefault(NumberParam, 1),
    limit: withDefault(NumberParam, 50)
  })

  const variables = {organisationId, ...filters}
  const {data, error: getError} = useQuery(QUERY, {variables})
  const response = data ? data.invoices : []

  return {
    filters,
    setFilters,
    errors: getError || {},
    invoices: response.collection || [],
    totalCount: response.metadata ? response.metadata.totalCount : 0
  }
}
